module.exports = __webpack_public_path__ + "static/media/dustin.35ce006d.png";